import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  queryString,
} from '../../../Util/commonUtility';
import {
  deleteEventOptionsById,
  getAllEventOptionsByEventId,
  getAllEventOptionsWithoutPagination,
} from './../../../Store/Actions/eventOptions';
import EventOptionsComponent from '../../../Components/AdminComponents/EventOptions';
import {useParams} from 'react-router-dom';

const EventOptionsContainer = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const {getAdminEventOptionsData, allEventOptionsWithoutPagination} =
    useSelector(({eventOptions}) => eventOptions);

  const [eventOptionsData, setEventOptionsData] = useState();
  const [sortParams, setSortParams] = useState({
    field: 'order_number',
    order: 'ascend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);
  const [totalEventOptionsCount, setTotalEventOptionsCount] = useState(10);

  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.eventOptions,
  );

  const [
    allEventOptionWithoutPaginationData,
    setAllEventOptionWithoutPaginationData,
  ] = useState();
  const [
    eventOptionsFetchingWithoutPagination,
    setEventOptionsFetchingWithoutPagination,
  ] = useState(false);
  useEffect(() => {
    if (getAdminEventOptionsData) {
      setEventOptionsData(getAdminEventOptionsData?.data?.eventOptions);
      setTotalEventOptionsCount(getAdminEventOptionsData?.data?.totalCount);
    } else {
      fetchEventOptionsByEventId(id);
    }
  }, [getAdminEventOptionsData]);

  useEffect(() => {
    fetchEventOptionsByEventId(id);
  }, [id]);

  useEffect(() => {
    if (allEventOptionsWithoutPagination) {
      setAllEventOptionWithoutPaginationData(
        allEventOptionsWithoutPagination?.data?.eventOptions,
      );
    }
  }, [allEventOptionsWithoutPagination?.data?.eventOptions]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchEventOptionsByEventId(id);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged]);

  const handleTableChange = (pagination, filter, sorter) => {
    setSortParams({
      field: sorter.field,
      order: sorter.order,
    });
    setPaginationAndSortChanged(true);
  };

  const fetchEventOptionsWithoutPagination = async (searchValues) => {
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = queryString(searchValues);
    dispatch(
      getAllEventOptionsWithoutPagination(
        id,
        sortField,
        sortOrder,
        searchQueryData,
        totalEventOptionsCount,
        setEventOptionsFetchingWithoutPagination,
      ),
    );
  };
  const fetchEventOptionsByEventId = (id) => {
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    dispatch(getAllEventOptionsByEventId(id, sortField, sortOrder));
  };

  const deleteEventOptions = (id) => {
    dispatch(deleteEventOptionsById(id));
  };

  return (
    <div>
      <EventOptionsComponent
        allEventOptionsData={eventOptionsData}
        handleTableChange={handleTableChange}
        sortParams={sortParams}
        fetchEventOptionsWithoutPagination={(searchValues) => {
          fetchEventOptionsWithoutPagination(searchValues);
        }}
        eventOptionsFetchingWithoutPagination={
          eventOptionsFetchingWithoutPagination
        }
        allEventOptionWithoutPaginationData={
          allEventOptionWithoutPaginationData
        }
        searchValues={searchValues}
        deleteEventOptions={(id) => {
          deleteEventOptions(id);
        }}
      />
    </div>
  );
};

export default EventOptionsContainer;
